import { ArrowContainer, Popover } from "react-tiny-popover";
import { getLocalizedString, theme } from "../../utils";
import { Box, Flex } from "rebass";
import OrderStatusGreen from "../../icons/OrderStatusGreen";
import OrderStatusYellow from "../../icons/OrderStatusYellow";
import OrderStatusRed from "../../icons/OrderStatusRed";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import config from "../../utils/globalConfig";
import { Price } from "../common/Price";
import { filter } from "lodash";

const OrderMetrics = () => {
  const { order, statusCode, totalReorder, maxSwap } = useSelector(
    (state) => state.yodaOrders,
  );
  const { budget } = useSelector((state) => state.yodaBudget);

  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const [flagColor, setFlagColor] = useState("");

  useEffect(() => {
    let color = "";
    if (statusCode == 2) color = "green";
    if (statusCode == 1) color = "yellow";
    if (statusCode == 0) color = "red";
    setFlagColor(color);
  }, [statusCode]);

  return (
    <Flex flex={1} justifyContent="flex-end" alignItems="center">
      <Flex
        alignItems={"center"}
        sx={{
          fontSize: "0.8em",
          color: "#232323",
          marginRight: ["8px", "8px", "30px"],
        }}
      >
        <Box sx={{ whiteSpace: "nowrap" }}>
          {getLocalizedString("TABMENU_ORDER_STATUS")}
        </Box>
        <Popover
          isOpen={isPopoverOpen}
          positions={["bottom"]}
          content={({ position, childRect, popoverRect }) => (
            <ArrowContainer
              position={position}
              childRect={childRect}
              popoverRect={popoverRect}
              arrowColor={"#545454"}
              arrowSize={12}
              arrowStyle={{ opacity: 1 }}
              arrowClassName="popover-arrow"
            >
              <Flex
                width={380}
                height={165}
                style={{
                  marginTop: 0,
                  marginLeft: 0,
                  backgroundColor: "#545454",
                  color: "#fff",
                  padding: 20,
                  borderRadius: 5,
                }}
                flexDirection={"column"}
              >
                <Flex style={{ fontSize: 12 }}>
                  <strong>
                    {getLocalizedString("TABMENU_ORDER_DESCRIPTION")}
                  </strong>
                </Flex>
                <Flex
                  mt={2}
                  style={{ fontSize: 12, height: 25 }}
                  alignItems={"center"}
                >
                  <OrderStatusGreen style={{ width: 20, marginRight: 5 }} />
                  {getLocalizedString("TABMENU_ORDER_OK")}
                </Flex>
                <Flex
                  style={{ fontSize: 12, height: 25 }}
                  alignItems={"center"}
                >
                  <OrderStatusYellow style={{ width: 20, marginRight: 5 }} />
                  {getLocalizedString("TABMENU_ORDER_WARN")}
                </Flex>
                <Flex
                  style={{ fontSize: 12, height: 25 }}
                  alignItems={"center"}
                >
                  <OrderStatusRed style={{ width: 20, marginRight: 5 }} />
                  {getLocalizedString("TABMENU_ORDER_ERROR")}
                </Flex>
              </Flex>
            </ArrowContainer>
          )}
        >
          <div
            onMouseEnter={() => setIsPopoverOpen(true)}
            onMouseLeave={() => setIsPopoverOpen(false)}
          >
            {flagColor === "green" && (
              <OrderStatusGreen style={{ width: 16, height: 16 }} />
            )}
            {flagColor === "yellow" && (
              <OrderStatusYellow style={{ width: 16, height: 16 }} />
            )}
            {flagColor == "red" && (
              <OrderStatusRed style={{ width: 16, height: 16 }} />
            )}
          </div>
        </Popover>
      </Flex>
      <Flex
        sx={{
          marginRight: ["8px", "8px", "30px"],
        }}
      >
        {order?.orderTypeId == config.ORDER_TYPE_REORDER && (
          <Flex
            alignItems={"center"}
            style={{
              fontSize: "0.8em",
              color: "#232323",
            }}
          >
            <Box sx={{ whiteSpace: "nowrap" }}>
              {getLocalizedString("TABMENU_MAX")}{" "}
            </Box>
            <Price
              negativeAsColor={true}
              price={budget?.maxRestock - totalReorder}
              style={{
                fontSize: "1.1em",
                color:
                  totalReorder > Number(budget?.maxRestock)
                    ? theme.redText
                    : theme.blueText,
                marginLeft: 3,
              }}
            />
          </Flex>
        )}
        {order?.orderTypeId == config.ORDER_TYPE_SWAP && (
          <Flex
            alignItems={"center"}
            style={{
              fontSize: "0.8em",
              color: "#232323",
            }}
          >
            <Box sx={{ whiteSpace: "nowrap" }}>
              {getLocalizedString("TABMENU_THRESHOLD")}{" "}
            </Box>
            <Price
              negativeAsColor={true}
              price={maxSwap}
              style={{
                fontSize: "1.1em",
                color: maxSwap < 0 ? theme.redText : theme.blueText,
                marginLeft: 3,
              }}
            />
          </Flex>
        )}
      </Flex>
    </Flex>
  );
};

export default OrderMetrics;
